import request from '@/utils/request'

// 分页查询公告列表
export function pageNotice(query) {
  return request({
    url: '/pa/xcx/paxcxpro/admin/health-information/page',
    method: 'post',
    data: query
  })
}

// 查询公告详细
export function getNotice(noticeId) {
  return request({
    url: '/pa/xcx/paxcxpro/admin/health-information/detail',
    method: 'post',
    data: noticeId
  })
}

// 新增公告
export function addNotice(data) {
  return request({
    url: '/pa/xcx/paxcxpro/admin/health-information/add',
    method: 'post',
    data: data
  })
}

// 修改公告
export function updateNotice(data) {
  return request({
    url: '/pa/xcx/paxcxpro/admin/health-information/update',
    method: 'post',
    data: data
  })
}

// 删除公告
export function delNotice(noticeId) {
  return request({
    url: '/pa/xcx/paxcxpro/admin/health-information/delete',
    method: 'post',
    data: noticeId
  })
}
// 上传图片
export function uploadImg(data) {
  return request({
    url: '/pa/xcx/paxcxpro/admin/common/uploadT',
    headers: {'Content-Type': 'multipart/form-data'},
    method: 'post',
    data: data
  })
}
